const keyUser = "campla_user";
const keyToken = "campla_token";
const keyTableConfigs = "campla_table_configs";

class StorageService {
  static setToken(v) {
    StorageService.set(keyToken, v);
  }

  static getToken() {
    return StorageService.getPrimitive(keyToken);
  }

  static setUser(v) {
    StorageService.set(keyUser, v);
  }

  static getUser() {
    return StorageService.getReferenceType(keyUser);
  }

  static getTableConfigs() {
    return StorageService.getReferenceType(keyTableConfigs, undefined, true);
  }

  static setTableConfigValue(tableId, tableKey, tableValue) {
    let tableConfigs = StorageService.getTableConfigs() || {};

    let valueUpdate = {};
    if (tableKey === "filter" && tableValue.length === 0) {
      delete tableConfigs[tableId]["filter"];
    }else{
      valueUpdate[tableKey] = tableValue;
      tableConfigs[tableId] = Object.assign(
          {},
          tableConfigs[tableId],
          valueUpdate
      );
    }

    StorageService.set(keyTableConfigs, tableConfigs, undefined, true);
  }

  static hasTableConfig(tableId){
    const tableConfigs = StorageService.getTableConfigs() || {};
    const hasTable = typeof tableConfigs[tableId] !== "undefined";
    return hasTable
        && typeof tableConfigs[tableId]["showFilters"] !== "undefined"
        && Object.keys(tableConfigs[tableId]).length > 1;
  }

  static hasTableConfigFilter(tableId){
    const tableConfigs = StorageService.getTableConfigs() || {};
    return typeof tableConfigs[tableId] !== "undefined" && typeof tableConfigs[tableId]["filter"] !== "undefined";
  }

  static tableConfigShowFilters(tableId){
    const tableConfigs = StorageService.getTableConfigs() || {};
    return (typeof tableConfigs[tableId] !== "undefined" && typeof tableConfigs[tableId]["filter"] !== "undefined")
         || (
             typeof tableConfigs[tableId] !== "undefined"
            && typeof tableConfigs[tableId]["showFilters"] !== "undefined"
        && tableConfigs[tableId]["showFilters"]);
  }

  static clearTableConfigs(tableId){
    let tableConfigs = StorageService.getTableConfigs() || {};
    if (typeof tableConfigs[tableId] !== "undefined") {
      delete tableConfigs[tableId];
    }
    StorageService.set(keyTableConfigs, tableConfigs, undefined, true);
  }

  static getTableConfigValue(tableId, tableKey) {
    let tableConfigs = StorageService.getTableConfigs();
    if (tableConfigs) {
      let tableConfig = tableConfigs[tableId];
      if (tableConfig) return tableConfig[tableKey];
    }
  }

  static set(k, v, type, local = false) {
    if (typeof type !== "undefined") {
      switch (type) {
        case "map":
          v = JSON.stringify([...v.entries()]);
          break;
        default:
      }
    }
    try {
      const storage = local ? localStorage : sessionStorage;
      if (Array.isArray(v) || typeof v === "object") {
        storage.setItem(k, JSON.stringify(v));
      } else {
        storage.setItem(k, v);
      }
    }catch (err){
      console.error(err);
    }
  }


  static getReferenceType(k, type, local = false) {
    const storage = local ? localStorage : sessionStorage;
    switch (type) {
      case "map":
        return storage.getItem(k)
          ? JSON.parse(storage.getItem(k)).reduce(
              (m, [key, val]) => m.set(key, val),
              new Map()
            )
          : null;
      default:
        return storage.getItem(k)
          ? JSON.parse(storage.getItem(k))
          : null;
    }
  }

  static getPrimitive(k, local = false) {
    const storage = local ? localStorage : sessionStorage;
    return storage.getItem(k);
  }

  static remove(k, local = false) {
    const storage = local ? localStorage : sessionStorage;
    if (storage.getItem(k)) storage.removeItem(k);
  }

  static clear(local = false) {
    const storage = local ? localStorage : sessionStorage;
    storage.clear();
  }

  static getPaginationTableIndex(view) {
    const paginationTableIndexes = this.getReferenceType("paginationTable");
    if (!paginationTableIndexes) return null;
    if (paginationTableIndexes[view]) {
      return paginationTableIndexes[view];
    }
  }

  static setPaginationTableIndex(view, index) {
    const paginationTableIndexes =
      this.getReferenceType("paginationTable") || {};
    paginationTableIndexes[view] = index;
    this.set("paginationTable", paginationTableIndexes);
  }
}


export default StorageService;
